import { atomWithStorage } from 'jotai/utils'
import { atom } from 'jotai/vanilla'

import { LoginStatus, STORAGE_KEY } from '@/constants/common'
import { AirdropDetail } from '@/hooks/services/useAirdrop'
import { Token } from '@/hooks/services/useTokenInfo'
import { TwitterAuthState } from '@/hooks/services/useTwitterAuth'
import { UserInfo } from '@/hooks/services/useUserInfo'
import SocketIO from '@/lib/SocketIO'
import { getUrlParams } from '@/lib/utils'

export const socketIOAtom = atom<SocketIO>(new SocketIO())

export const tokenMapAtom = atomWithStorage<Record<string, string>>(
  STORAGE_KEY.TOKEN_MAP,
  {},
  undefined,
  {
    getOnInit: true
  }
)

export const userInfoAtom = atomWithStorage<UserInfo | null>(
  STORAGE_KEY.USERINFO,
  null,
  undefined,
  {
    getOnInit: true
  }
)

export const loginStatusAtom = atomWithStorage<LoginStatus>(
  STORAGE_KEY.LOGIN_STATUS,
  LoginStatus.LOGOUT,
  undefined,
  {
    getOnInit: true
  }
)

export const solPriceUsdAtom = atomWithStorage<number | undefined>(
  STORAGE_KEY.SOL_PRICE_USD,
  undefined,
  undefined,
  {
    getOnInit: true
  }
)

export const tokenInfoAtom = atom<Token | null>(null)

export const likePostIdsAtom = atom<number[]>([])

// export const tradeEventAtom = atom<{ txHash: string }>()

export const airdropDetailAtom = atomWithStorage<AirdropDetail | undefined>(
  STORAGE_KEY.AIRDROP_DETAIL,
  undefined,
  undefined,
  {
    getOnInit: true
  }
)

export const claimTimeAtom = atomWithStorage<string>(
  STORAGE_KEY.CLAIM_TIME,
  '',
  undefined,
  {
    getOnInit: true
  }
)

const [state, code] = [getUrlParams('state'), getUrlParams('code')]
export const twitterAuthStateAtom = atomWithStorage<TwitterAuthState>(
  STORAGE_KEY.TWITTER_AUTH,
  state && code ? TwitterAuthState.REDIRECTING : TwitterAuthState.UN_KNOWN,
  undefined,
  { getOnInit: true }
)
